import { Button, WarningStateScreen } from '@approvalmax/ui';
import { DefaultPageLayout } from 'modules/page';
import { memo } from 'react';
import { routingService } from 'services/routing';

import { messages } from './PageError.messages';
import { Card, Content } from './PageError.styles';

const PageError = memo(() => {
    const goToRequiresMyDecision = () => {
        routingService.reloadToDefaultPath();
    };

    return (
        <DefaultPageLayout documentTitle={messages.notFoundPage}>
            <Content>
                <Card>
                    <WarningStateScreen title={messages.errorText} description={messages.errorDescription} />

                    <Button execute={goToRequiresMyDecision}>{messages.goToRequiresMyDecision}</Button>
                </Card>
            </Content>
        </DefaultPageLayout>
    );
});

export default PageError;
